// extracted by mini-css-extract-plugin
module.exports = {"page":"Mbb3f","page_bg_gray":"i7kfm","page_bg_white":"Ka411"};